interface NotificationToastProps {
  message: string | null
}

export function NotificationToast({ message }: NotificationToastProps) {
  if (!message) return null

  return (
    <div className="absolute bottom-32 left-1/2 -translate-x-1/2 z-50 animate-bounce-in pointer-events-none">
      <div className="bg-dark-800/90 text-white px-5 py-2.5 rounded-full border border-white/10 shadow-xl backdrop-blur-md flex items-center gap-2">
        <svg
          className="w-4 h-4 text-brand-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        <span className="text-sm font-medium">{message}</span>
      </div>
    </div>
  )
}
